import { render, staticRenderFns } from "./SubmissionSidebar.vue?vue&type=template&id=75ed52dc&"
import script from "./SubmissionSidebar.vue?vue&type=script&lang=js&"
export * from "./SubmissionSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports